/**
 * Parser pro řetězec popisující "techniku další jednotky" ve formátu:
 *   "Jednotka: Typ vozidla [- ]Volací znak"
 *
 * Volací znak je rozpoznán regulárním výrazem na konci řetězce — typicky
 * 2–4 velká písmena (HOP, POP, PHL, JPO, …) + volitelná pomlčka/mezera + 1–4 číslic.
 * Pokud regex nezachytí, celý zbytek je v `typ` a `volaci` zůstane prázdný.
 */
const VOLACI_REGEX = /\s+([A-ZÁ-Ž]{2,4}\s*[-]?\s*\d{1,4})\s*$/;

export interface ParsedPosila {
    jednotka: string;
    typ: string;
    volaci: string;
}

export const parsePosila = (s: string): ParsedPosila => {
    const colonIdx = s.indexOf(':');
    const jednotka = colonIdx >= 0 ? s.slice(0, colonIdx).trim() : '';
    const rest = colonIdx >= 0 ? s.slice(colonIdx + 1).trim() : s.trim();

    const match = rest.match(VOLACI_REGEX);
    if (match && match.index !== undefined) {
        const volaci = match[1].trim();
        // Odřízneme trailing ' - ' nebo '-' z typu (BE často odděluje volací znak pomlčkou).
        const typ = rest.slice(0, match.index).replace(/\s*-+\s*$/, '').trim();
        return { jednotka, typ, volaci };
    }

    return { jednotka, typ: rest, volaci: '' };
};
